var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryDarkgrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#3f414a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.163 -489.555)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15,
    height: 18,
    transform: "translate(23.163 489.555)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.04,16.385H1.045A1.044,1.044,0,0,1,0,15.344V2.081A1.044,1.044,0,0,1,1.045,1.042h.518v-.2C1.563.377,1.8,0,2.086,0H5.995c.288,0,.523.377.523.839v.2H7.04A1.041,1.041,0,0,1,8.081,2.081V15.344A1.042,1.042,0,0,1,7.04,16.385ZM3.147,9.68h0l-.408,3a.277.277,0,0,0,.274.313.263.263,0,0,0,.062-.007.276.276,0,0,0,.17-.119l3.3-5.1a.274.274,0,0,0-.006-.308.277.277,0,0,0-.289-.11L5.087,7.62l.321-2.987A.277.277,0,0,0,4.9,4.456L1.7,9.528a.274.274,0,0,0,.009.307A.276.276,0,0,0,2,9.944L3.146,9.68Z",
    transform: "translate(26.534 490.564)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryDarkgrey);
export default __webpack_public_path__ + "static/media/battery_darkgrey.3ecf2796c289e31b8c52adf46cdefc7f.svg";
export { ForwardRef as ReactComponent };